import React from 'react'
import '../../styles/services.css'
import servicesData from '../../data/servicesData.json'

const Services = () => {
  return (
      <section id="services">
          <div className="container">
              <div className="service__top-content">
                  <h6 className="subtitle">Nossos Serviços</h6>
                  <h2>Salve tempo e ganhe qualidade</h2>
                  <h2 className="highlight">com o melhor dos nossos serviços</h2>
              </div>
              <div className="service__item-wrapper">
                  {
                      servicesData.map((item, index) => (
                        <div key={index} className="services__item">
                        <span className="service__icon">
                              <i className={item.icon}></i>
                        </span>
                              <h3 className="service__title">{item.title}</h3>
                        <p className="description">
                            {item.description}
                        </p>
                    </div>
                      ))
                  }
              </div>
          </div>
   </section>
  )
}

export default Services
